module.exports = "<!-- Footer Info -->\n<section id=\"contact\" class=\"footer-info white-bg\">\n\n</section>\n"